/**
 * Checks if the codice Fiscale is valid
 *
 * @param {string} codiceFiscale The Codice Fiscale
 * @returns {boolean} does it satisfy Codice Fiscale regex
 */
export const isValidCodiceFiscale = (codiceFiscale) => (/^[A-Za-z]{6}[0-9]{2}[A-Za-z]{1}[0-9]{2}[A-Za-z]{1}[0-9]{3}[A-Za-z]{1}$/i).test(codiceFiscale);